import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";
import { LoadingButton } from "@mui/lab";
import { DeleteOutline } from "@mui/icons-material";

TableBulkDelete.propTypes = {
  startDelete: PropTypes.bool,
  setStartDelete: PropTypes.func,
  setSelectedForDelete: PropTypes.func,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  confirmTitle: PropTypes.string,
}

export default function TableBulkDelete({
  startDelete,
  setStartDelete,
  setSelectedForDelete,
  loading,
  onSubmit,
  title = 'Delete',
  confirmTitle = 'Confirm Delete',
}) {
  return (
    <Box>
      <Button
        variant="outlined"
        size="small"
        color="error"
        sx={{ mr: 1 }}
        onClick={() => {
          setStartDelete((show) => !show);
          setSelectedForDelete([]);
        }}
        startIcon={<DeleteOutline />}
      >
        {startDelete ? `Cancel ${title}` : title}
      </Button>
      {startDelete && (
        <LoadingButton
          variant="contained"
          size="small"
          color="error"
          loading={loading}
          onClick={onSubmit}
          startIcon={<DeleteOutline />}
        >
          {confirmTitle}
        </LoadingButton>
      )}
    </Box>
  );
}